<template>
  <router-view />
</template>

<script>
export default {
  name: 'OhGroup',
}
</script>
